// ══════════════════════════════════════════════════
// MARK: Setup
// ──────────────────────────────────────────────────


// ══════════════════════════════════════════════════
// MARK: Upper Case First
// ──────────────────────────────────────────────────
export function upperCaseFirst(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}